import components from './components'
import constant from '~/locales/es/const'
export default {
  components,
  constant,
}
